// extracted by mini-css-extract-plugin
module.exports = {"groupItem":"_16Hm5IcJwH-4BrCOhfbdOk","label":"_1NP6jexHiK4YLxkdbo2DLN"};